export const translations = {
  en: {
    // Navbar
    nav: {
      home: 'Home',
      events: 'Events',
      news: 'Recent News',
      weekly: 'Weekly Activities',
      hallHire: 'Hall Hire',
      committee: 'Committee',
      groups: 'Associated Groups',
      constitution: 'Governance'
    },
    
    // Footer
    footer: {
      about: 'About',
      aboutText: 'Representing three generations of Poles who have made Newcastle their home. Preserving Polish culture and heritage.',
      quickLinks: 'Quick Links',
      contact: 'Contact Us',
      hallHours: 'Hall Hours',
      monFri: 'Mon - Fri',
      satSun: 'Sat - Sun',
      allRights: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use'
    },
    
    // Home Page
    home: {
      title: 'Polish Association of Newcastle',
      subtitle: 'Preserving Polish culture and heritage in Newcastle for three generations',
      viewEvents: 'View Events',
      hireHall: 'Hire Our Hall',
      welcomeTitle: 'Welcome to Our Community',
      ourHeritage: 'Our Heritage',
      heritage1: 'The Polish Association of Newcastle represents the achievements of three generations of Poles who have made Newcastle their home. We are dedicated to preserving and celebrating Polish culture, traditions, and heritage while fostering a strong sense of community.',
      heritage2: 'Our community hall serves as a vibrant hub for cultural activities, language education, traditional dance, dining, and social gatherings. Join us in celebrating the rich tapestry of Polish heritage in Australia.',
      meetCommittee: 'Meet Our Committee',
      eventsCalendar: 'Events Calendar',
      eventsDesc: 'Discover upcoming cultural celebrations and community events',
      viewCalendar: 'View Calendar',
      weeklyActivities: 'Weekly Activities',
      weeklyDesc: 'Regular programs including language classes and cultural activities',
      seeSchedule: 'See Schedule',
      hallHireTitle: 'Hall Hire',
      hallHireDesc: 'Book our beautiful venue for weddings, parties, and events',
      enquireNow: 'Enquire Now',
      associatedGroups: 'Associated Groups',
      groupsDesc: 'Connect with our schools, dance groups, and dining services',
      learnMore: 'Learn More',
      upcomingEvents: 'Upcoming Events',
      upcomingDesc: 'Join us for these exciting upcoming celebrations',
      viewAll: 'View All Events',
      joinCommunity: 'Join Our Community',
      joinDesc: 'Become part of our vibrant Polish community and help us preserve our rich cultural heritage for future generations',
      getInvolved: 'Get Involved'
    },
    
    // Events Page
    events: {
      title: 'Events Calendar',
      subtitle: 'Join us for cultural celebrations, educational programs, and community gatherings throughout the year',
      loading: 'Loading events...',
      noEvents: 'No events scheduled at this time.',
      stayUpdated: 'Stay Updated',
      stayDesc: 'Want to be notified about upcoming events? Contact us to join our mailing list.',
      subscribe: 'Subscribe to Updates'
    },
    
    // Weekly Activities
    weekly: {
      title: 'Weekly Activities',
      subtitle: 'Regular programs and activities at the Polish Cultural Centre',
      noActivities: 'No activities scheduled at this time.',
      joinTitle: 'Join Our Activities',
      joinDesc: 'All activities are held at the Polish Cultural Centre. Are you looking to host your own weekly activity? Get in touch with our hall coordinator.',
      contactUs: 'Contact Us',
      call: 'Call'
    },
    
    // Hall Hire
    hallHire: {
      title: 'Hall Hire',
      subtitle: 'Book our beautiful Polish Cultural Centre for your special event',
      ourVenue: 'Our Venue',
      facilitiesTitle: 'Facilities Included',
      capacity: 'Capacity: Up to 200 people',
      perfectFor: 'Perfect For',
      competitiveRates: 'Competitive Rates',
      ratesDesc: 'Contact us for pricing and package options.',
      makeEnquiry: 'Make an Enquiry',
      enquiryDesc: 'Fill out the form and we\'ll get back to you within 24 hours',
      checkAvailability: 'Check Availability',
      selected: 'Selected',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      eventType: 'Event Type',
      selectEvent: 'Select event type',
      wedding: 'Wedding',
      birthday: 'Birthday',
      christening: 'Christening',
      corporate: 'Corporate Event',
      other: 'Other',
      guests: 'Expected Number of Guests',
      message: 'Additional Information',
      messagePlaceholder: 'Tell us about your event...',
      submit: 'Submit Enquiry',
      successToast: 'Enquiry submitted successfully! We will contact you within 24 hours.',
      errorToast: 'Failed to submit enquiry. Please try again or contact us directly.',
      facilities: [
        'Full kitchen facilities',
        'Tables and chairs included',
        'Sound system available',
        'Dance floor',
        'Bar facilities',
        'Parking available',
        'Air conditioning/heating',
        'Disabled access'
      ],
      suitableFor: [
        'Weddings',
        'Birthdays',
        'Christenings',
        'Corporate events',
        'Community gatherings',
        'Cultural celebrations'
      ]
    },
    
    // Committee
    committee: {
      title: 'Our Committee',
      subtitle: 'Meet the dedicated team leading the Polish Association of Newcastle',
      joinTitle: 'Interested in becoming a Volunteer?',
      joinDesc: 'We\'re always looking for passionate individuals who want to contribute to preserving Polish culture and strengthening our community. Contact us to learn about volunteer opportunities.',
      contactCommittee: 'Contact Committee',
      memberTitle: 'Interested in becoming a Member?',
      memberDesc: 'Join our community and help preserve Polish culture in Newcastle. Download the membership form and submit it to us.',
      downloadForm: 'Download Membership Form',
      enquireMembership: 'Enquire About Membership',
      commitmentTitle: 'Our Commitment',
      generations: 'Generations',
      generationsDesc: 'Serving Polish families in Newcastle for three generations',
      eventsAnnually: 'Events Annually',
      eventsDesc: 'Cultural celebrations, educational programs, and community gatherings',
      volunteerRun: 'Volunteer Run',
      volunteerDesc: 'Dedicated volunteers committed to our community'
    },
    
    // Associated Groups
    groups: {
      title: 'Associated Groups',
      subtitle: 'Connect with our vibrant community organisations',
      schedule: 'Schedule',
      contact: 'Contact',
      getInTouch: 'Get in Touch',
      visitWebsite: 'Visit Website',
      startGroupTitle: 'Want to Start Your Own Group?',
      startGroupDesc: 'We welcome new initiatives that promote Polish culture and community engagement.',
      contactUs: 'Contact Us'
    },
    
    // Constitution
    constitution: {
      title: 'Constitution & Governance',
      subtitle: 'Official documents and governance information',
      agmTitle: 'Annual General Meeting 2025',
      agmDate: 'Saturday, 15 March 2025',
      agmTime: 'Polish Cultural Centre, 3:00 PM',
      agmDesc: 'All members are encouraged to attend our AGM. We\'ll review achievements and hold committee elections.',
      downloadNotice: 'Download AGM Notice',
      officialDocs: 'Official Documents',
      docsDesc: 'Access our constitution, minutes, and reports',
      download: 'Download',
      aboutConstitution: 'About Our Constitution',
      constitutionDesc1: 'The Constitution outlines fundamental principles governing our organization, defining our mission, membership, and structure.',
      constitutionDesc2: 'Ensures transparent democratic governance while maintaining our commitment to Polish culture and heritage.',
      membershipTitle: 'Membership Information',
      whoCanJoin: 'Who Can Join?',
      whoDesc: 'Open to all interested in Polish culture and heritage. Just download a membership form from this page and send us the completed form using the link below.',
      benefits: 'Benefits',
      benefit1: 'Voting rights at AGM',
      benefit2: 'Discounted event tickets',
      benefit3: 'Priority hall booking',
      benefit4: 'Member-only events',
      applyMembership: 'Apply for Membership',
      usefulLinks: 'Useful Links',
      usefulLinksDesc: 'Connect with Polish organisations and resources in Australia',
      questionsTitle: 'Questions About Governance?',
      questionsDesc: 'Contact our committee for any questions.',
      contactCommittee: 'Contact Committee'
    },
    
    // News
    news: {
      title: 'Recent News',
      subtitle: 'Stay updated with the latest news and events from our Polish community',
      readMore: 'Read More',
      stayConnected: 'Stay Connected',
      stayConnectedDesc: 'Subscribe to our newsletter to receive the latest news and updates from the Polish Association of Newcastle.',
      subscribe: 'Subscribe to Newsletter'
    },
    
    common: {
      loading: 'Loading...',
      learnMore: 'Learn More'
    }
  },
  
  pl: {
    // Navbar
    nav: {
      home: 'Strona Główna',
      events: 'Wydarzenia',
      news: 'Aktualności',
      weekly: 'Zajęcia Tygodniowe',
      hallHire: 'Wynajem Sali',
      committee: 'Zarząd',
      groups: 'Grupy Stowarzyszone',
      constitution: 'Zarządzanie'
    },
    
    // Footer
    footer: {
      about: 'O Nas',
      aboutText: 'Reprezentujemy osiągnięcia trzech pokoleń Polaków, którzy uczynili Newcastle swoim domem. Zachowujemy polską kulturę i dziedzictwo.',
      quickLinks: 'Szybkie Linki',
      contact: 'Kontakt',
      hallHours: 'Godziny Otwarcia',
      monFri: 'Pon - Pt',
      satSun: 'Sob - Niedz',
      allRights: 'Wszelkie prawa zastrzeżone',
      privacy: 'Polityka Prywatności',
      terms: 'Warunki Użytkowania'
    },
    
    // Home Page
    home: {
      title: 'Polskie Stowarzyszenie w Newcastle',
      subtitle: 'Zachowujemy polską kulturę i dziedzictwo w Newcastle od trzech pokoleń',
      viewEvents: 'Zobacz Wydarzenia',
      hireHall: 'Wynajmij Salę',
      welcomeTitle: 'Witamy w Naszej Społeczności',
      ourHeritage: 'Nasze Dziedzictwo',
      heritage1: 'Polskie Stowarzyszenie w Newcastle reprezentuje osiągnięcia trzech pokoleń Polaków, którzy uczynili Newcastle swoim domem. Jesteśmy zaangażowani w zachowanie i celebrowanie polskiej kultury, tradycji i dziedzictwa, jednocześnie budując silne poczucie wspólnoty.',
      heritage2: 'Nasza sala społeczności służy jako tętniący życiem ośrodek działalności kulturalnej, edukacji językowej, tańców tradycyjnych, gastronomii i spotkań towarzyskich. Dołącz do nas w celebrowaniu bogatej tkaniny polskiego dziedzictwa w Australii.',
      meetCommittee: 'Poznaj Nasz Zarząd',
      eventsCalendar: 'Kalendarz Wydarzeń',
      eventsDesc: 'Odkryj nadchodzące uroczystości kulturalne i wydarzenia społeczne',
      viewCalendar: 'Zobacz Kalendarz',
      weeklyActivities: 'Zajęcia Tygodniowe',
      weeklyDesc: 'Regularne programy obejmujące lekcje języka i zajęcia kulturalne',
      seeSchedule: 'Zobacz Harmonogram',
      hallHireTitle: 'Wynajem Sali',
      hallHireDesc: 'Zarezerwuj naszą piękną salę na wesela, przyjęcia i wydarzenia',
      enquireNow: 'Zapytaj Teraz',
      associatedGroups: 'Grupy Stowarzyszone',
      groupsDesc: 'Połącz się z naszymi szkołami, grupami tanecznymi i usługami gastronomicznymi',
      learnMore: 'Dowiedz Się Więcej',
      upcomingEvents: 'Nadchodzące Wydarzenia',
      upcomingDesc: 'Dołącz do nas na te ekscytujące nadchodzące uroczystości',
      viewAll: 'Zobacz Wszystkie Wydarzenia',
      joinCommunity: 'Dołącz do Naszej Społeczności',
      joinDesc: 'Stań się częścią naszej tętniącej życiem polskiej społeczności i pomóż nam zachować nasze bogate dziedzictwo kulturowe dla przyszłych pokoleń',
      getInvolved: 'Zaangażuj Się'
    },
    
    // Events Page
    events: {
      title: 'Kalendarz Wydarzeń',
      subtitle: 'Dołącz do nas na uroczystości kulturalne, programy edukacyjne i spotkania społeczności przez cały rok',
      loading: 'Ładowanie wydarzeń...',
      noEvents: 'Brak zaplanowanych wydarzeń w tym czasie.',
      stayUpdated: 'Bądź Na Bieżąco',
      stayDesc: 'Chcesz otrzymywać powiadomienia o nadchodzących wydarzeniach? Skontaktuj się z nami, aby dołączyć do naszej listy mailingowej.',
      subscribe: 'Zapisz się na Aktualizacje'
    },
    
    // Weekly Activities
    weekly: {
      title: 'Zajęcia Tygodniowe',
      subtitle: 'Regularne programy i zajęcia w Polskim Domu Kultury',
      noActivities: 'Brak zaplanowanych zajęć w tym czasie.',
      joinTitle: 'Dołącz do Naszych Zajęć',
      joinDesc: 'Wszystkie zajęcia odbywają się w Polskim Domu Kultury. Chcesz prowadzić własne cotygodniowe zajęcia? Skontaktuj się z naszym koordynatorem sali.',
      contactUs: 'Skontaktuj Się',
      call: 'Zadzwoń'
    },
    
    // Hall Hire
    hallHire: {
      title: 'Wynajem Sali',
      subtitle: 'Zarezerwuj naszą piękną Polską Salę Społeczności na Twoje wyjątkowe wydarzenie',
      ourVenue: 'Nasza Sala',
      facilitiesTitle: 'Udogodnienia w Cenie',
      capacity: 'Pojemność: Do 200 osób',
      perfectFor: 'Idealna Na',
      competitiveRates: 'Konkurencyjne Ceny',
      ratesDesc: 'Skontaktuj się z nami w sprawie cen i pakietów.',
      makeEnquiry: 'Złóż Zapytanie',
      enquiryDesc: 'Wypełnij formularz, a skontaktujemy się w ciągu 24 godzin',
      checkAvailability: 'Sprawdź Dostępność',
      selected: 'Wybrano',
      fullName: 'Imię i Nazwisko',
      email: 'Email',
      phone: 'Telefon',
      eventType: 'Typ Wydarzenia',
      selectEvent: 'Wybierz typ wydarzenia',
      wedding: 'Wesele',
      birthday: 'Urodziny',
      christening: 'Chrzciny',
      corporate: 'Wydarzenie Firmowe',
      other: 'Inne',
      guests: 'Oczekiwana Liczba Gości',
      message: 'Dodatkowe Informacje',
      messagePlaceholder: 'Opowiedz nam o swoim wydarzeniu...',
      submit: 'Wyślij Zapytanie',
      successToast: 'Zapytanie wysłane pomyślnie! Skontaktujemy się w ciągu 24 godzin.',
      errorToast: 'Nie udało się wysłać zapytania. Spróbuj ponownie lub skontaktuj się bezpośrednio.',
      facilities: [
        'Pełne zaplecze kuchenne',
        'Stoły i krzesła w cenie',
        'System nagłośnienia',
        'Parkiet taneczny',
        'Zaplecze barowe',
        'Parking dostępny',
        'Klimatyzacja/ogrzewanie',
        'Dostęp dla niepełnosprawnych'
      ],
      suitableFor: [
        'Wesela',
        'Urodziny',
        'Chrzciny',
        'Imprezy firmowe',
        'Spotkania społeczności',
        'Uroczystości kulturalne'
      ]
    },
    
    // Committee
    committee: {
      title: 'Nasz Zarząd',
      subtitle: 'Poznaj oddany zespół prowadzący Polskie Stowarzyszenie w Newcastle',
      joinTitle: 'Zainteresowany Wolontariatem?',
      joinDesc: 'Zawsze szukamy pasjonatów, którzy chcą przyczynić się do zachowania polskiej kultury i wzmocnienia naszej społeczności. Skontaktuj się z nami, aby dowiedzieć się o możliwościach wolontariatu.',
      contactCommittee: 'Skontaktuj się z Zarządem',
      memberTitle: 'Chcesz zostać Członkiem?',
      memberDesc: 'Dołącz do naszej społeczności i pomagaj w zachowaniu polskiej kultury w Newcastle. Pobierz formularz zgłoszeniowy i wyślij go do nas.',
      downloadForm: 'Pobierz Formularz Członkowski',
      enquireMembership: 'Zapytaj o Członkostwo',
      commitmentTitle: 'Nasze Zaangażowanie',
      generations: 'Pokolenia',
      generationsDesc: 'Służymy polskim rodzinom w Newcastle przez trzy pokolenia',
      eventsAnnually: 'Wydarzeń Rocznie',
      eventsDesc: 'Uroczystości kulturalne, programy edukacyjne i spotkania społeczności',
      volunteerRun: 'Prowadzone Wolontariacko',
      volunteerDesc: 'Oddani wolontariusze zaangażowani w naszą społeczność'
    },
    
    // Associated Groups
    groups: {
      title: 'Grupy Stowarzyszone',
      subtitle: 'Połącz się z naszymi tętniącymi życiem organizacjami społecznymi',
      schedule: 'Harmonogram',
      contact: 'Kontakt',
      getInTouch: 'Skontaktuj Się',
      visitWebsite: 'Odwiedź Stronę',
      startGroupTitle: 'Chcesz Założyć Własną Grupę?',
      startGroupDesc: 'Witamy nowe inicjatywy promujące polską kulturę i zaangażowanie społeczności.',
      contactUs: 'Skontaktuj Się z Nami'
    },
    
    // Constitution
    constitution: {
      title: 'Konstytucja i Zarządzanie',
      subtitle: 'Oficjalne dokumenty i informacje o zarządzaniu',
      agmTitle: 'Walne Zebranie Członków 2025',
      agmDate: 'Sobota, 15 marca 2025',
      agmTime: 'Polska Sala Społeczności, 15:00',
      agmDesc: 'Wszyscy członkowie są zachęcani do udziału w naszym WZC. Przeanalizujemy osiągnięcia i przeprowadzimy wybory do zarządu.',
      downloadNotice: 'Pobierz Zawiadomienie WZC',
      officialDocs: 'Oficjalne Dokumenty',
      docsDesc: 'Dostęp do naszej konstytucji, protokołów i raportów',
      download: 'Pobierz',
      aboutConstitution: 'O Naszej Konstytucji',
      constitutionDesc1: 'Konstytucja określa fundamentalne zasady rządzące naszą organizacją, definiując naszą misję, członkostwo i strukturę.',
      constitutionDesc2: 'Zapewnia przejrzyste demokratyczne zarządzanie, zachowując nasze zaangażowanie w polską kulturę i dziedzictwo.',
      membershipTitle: 'Informacje o Członkostwie',
      whoCanJoin: 'Kto Może Dołączyć?',
      whoDesc: 'Otwarte dla wszystkich zainteresowanych polską kulturą i dziedzictwem.',
      benefits: 'Korzyści',
      benefit1: 'Prawo głosu na WZC',
      benefit2: 'Zniżki na bilety na wydarzenia',
      benefit3: 'Priorytetowa rezerwacja sali',
      benefit4: 'Wydarzenia tylko dla członków',
      applyMembership: 'Aplikuj o Członkostwo',
      usefulLinks: 'Przydatne Linki',
      usefulLinksDesc: 'Połącz się z polskimi organizacjami i zasobami w Australii',
      questionsTitle: 'Pytania o Zarządzanie?',
      questionsDesc: 'Skontaktuj się z naszym zarządem w sprawie pytań.',
      contactCommittee: 'Skontaktuj się z Zarządem'
    },
    
    // News
    news: {
      title: 'Aktualności',
      subtitle: 'Bądź na bieżąco z najnowszymi wiadomościami i wydarzeniami z naszej polskiej społeczności',
      readMore: 'Czytaj Więcej',
      stayConnected: 'Bądź w Kontakcie',
      stayConnectedDesc: 'Zapisz się do naszego newslettera, aby otrzymywać najnowsze wiadomości i aktualizacje od Polskiego Stowarzyszenia w Newcastle.',
      subscribe: 'Zapisz się do Newslettera'
    },
    
    common: {
      loading: 'Ładowanie...',
      learnMore: 'Dowiedz Się Więcej'
    }
  }
};

export const t = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};
